import { createApp } from '@app/adapters/create-app'
import createStore from '@app/insights/store'
import { initInsightsRootFromDataset } from '@app/insights/store/insights-root'
import type { Store } from 'vuex'

import InsightsCompaniesStatus from '@app/insights/components/companies/companies-list-status.vue'
import type { App as Application } from 'vue'

window.onDomLoad(function ($dom) {
  const doc = $dom[0]
  const element = doc.querySelector(
    "[data-behaviour='insights/subnav-right']"
  ) as HTMLElement

  if (element) {
    const store = createStore() as Store<unknown>

    const insightStatusApp: Application = createApp(InsightsCompaniesStatus, {
      isLite: element.dataset.liteInsights === 'true',
    })

    insightStatusApp.use(store)

    initInsightsRootFromDataset(element.dataset)

    insightStatusApp.mount(element)
  }
})
